<!-- PWA Install Prompt -->
@if (showInstallPrompt && isInstallable) {
  <div
    class="fixed bottom-6 left-6 right-6 z-50 max-w-sm rounded-lg border border-gray-200 bg-white p-4 shadow-lg md:left-auto md:right-6"
    >
    <div class="flex flex-col gap-4">
      <div>
        <h3 class="font-semibold text-gray-900">Install PadelHub</h3>
        <p class="mt-1 text-sm text-gray-600">
          Add PadelHub to your home screen for quick access and offline functionality.
        </p>
      </div>
      <div class="flex gap-3">
        <button
          (click)="dismissInstallPrompt()"
          class="flex-1 rounded-md border border-gray-300 px-3 py-2 text-center text-sm font-medium text-gray-700 hover:bg-gray-50"
          >
          Later
        </button>
        <button
          (click)="installApp()"
          class="flex-1 rounded-md bg-primary-500 px-3 py-2 text-center text-sm font-medium text-white hover:bg-primary-600"
          >
          Install
        </button>
      </div>
    </div>
  </div>
}

<router-outlet></router-outlet>
